import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Page from 'components/system/Page';
import jobWaitingAnimation from 'assets/animation/quantum_job_animation.mp4';
// import Paper from 'components/system/Paper';
// import QuantumCountdown from 'components/system/QuantumCoundown';
// import colors from 'styles/colors';
// import { jobInProgressStatuses } from 'constants/jobs';
// import { createQuantumWindowsMessage, isInQuantumWindow } from 'utils/time';
import JobStateVectorChart from './JobStateVectorChart';
import JobCircuit from './JobCircuit';
import JobDetails from './JobDetails';

// const quantumText = (
//   <>
//     <QuantumCountdown />
//     <div key="quantumInfo">
//       👋 Your quantum job will be run when the device comes online.
//       {' '}
//       <p> The quantum device is only available during these times:</p>
//       <div>
//         {
//           createQuantumWindowsMessage().map(
//             (message) => (
//               <p
//                 key={message}
//                 style={{ fontFamily: 'monospace', fontSize: '14px', lineHeight: '20px' }}
//               >
//                 {message}
//               </p>
//             ),
//           )
//         }
//       </div>
//
//     </div>
//   </>
// );

const Job = ({ isLoading, isInProgress, ...details }) => {
  const {
    circuitJson,
    top128: chartData,
    resultsPath: statevectorResourceLink,
    hasStatevector,
    runStatus,
    numQubits,
    numGatesExceedsLimit,
  } = details;

  return (
    <Container>
      <Page withBackButton>
        <Grid container direction="row" spacing={3}>
          {/* <Grid item xs={12}> */}
          {/*  {runStatus === jobInProgressStatuses.JOB_QUEUED_STATUS && !isInQuantumWindow() && ( */}
          {/*    <Paper */}
          {/*      sx={{ color: colors.text.secondary, backgroundColor: colors.primary.shade_16p }} */}
          {/*    > */}
          {/*      {quantumText} */}
          {/*    </Paper> */}
          {/*  )} */}
          {/* </Grid> */}
          <Grid item xs={12}>
            <JobDetails isLoading={isLoading} {...details} />
          </Grid>
          <Grid item xs={12}>
            {
              !isInProgress ? (
                <JobStateVectorChart
                  isLoading={isLoading}
                  chartData={chartData}
                  statevectorResourceLink={statevectorResourceLink}
                  canExport={!!hasStatevector}
                  numQubits={numQubits}
                />
              ) : (
                <Box>
                  <video
                    autoPlay
                    loop
                    muted
                    style={{
                      height: '100%',
                      width: '100%',
                      borderRadius: '24px',
                    }}
                  >
                    <source src={jobWaitingAnimation} type="video/mp4" />
                  </video>
                </Box>
              )
            }
          </Grid>
          <Grid item xs={12}>
            <JobCircuit data={circuitJson} isLarge={numGatesExceedsLimit} />
          </Grid>
        </Grid>
      </Page>
    </Container>
  );
};

export default Job;
